import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ReferralRegistration = React.lazy(() =>
    import('../ReferralRegistration')
);
const referralRegistrationRoutesRegistry = [
    {
        path: PAGE_URL.REFERRAL_REGISTRATION_PAGE,
        element: <ReferralRegistration />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default referralRegistrationRoutesRegistry;
